<template>
  <div class="waterSystem">
    <nav class="navbar">
      <div class="navbar_left">
        <img src="./img/logo.png" alt="" />
        <h1>消防水系统全生命周期监测</h1>
      </div>
      <div class="navbar_right">
        <!-- AI助手按钮 -->
        <button class="ai-assistant-btn" @click="showAiAssistant = true">
          AI助手
        </button>
        <span class="date">{{ currentDate }}</span>
        <span class="week">{{ weekDay }}</span>
        <span class="time">{{ currentTime }}</span>
      </div>
      <span class="exit" @click="backHome">
        <img src="./img/exit_dark.png" />
      </span>
    </nav>
    <div class="waterSystem-container">
      <aside class="sidebar" :class="isExpanded ? 'expanded' : 'collapsed'">
        <ul class="menuList">
          <li class="menuItem" v-for="item in menuList" :key="item.id">
            <a
              class="menu-link"
              :class="{ active: activeMenu === item.id }"
              @click="changeNav(item)"
            >
              <div class="icon-container">
                <img :src="item.icon" class="default-icon" />
                <img :src="item.hoverIcon || item.icon" class="hover-icon" />
              </div>
              <span class="menu-text" v-if="isExpanded">{{ item.name }}</span>
            </a>
          </li>
        </ul>
        <div class="bottom">
          <div class="toggle" @click="isExpanded = !isExpanded">
            <img
              :src="isExpanded ? require('./img/left_dark.png') : require('./img/right_dark.png')"
            />
            <span class="toggle_text" v-if="isExpanded">菜单收起</span>
          </div>
        </div>
      </aside>
      <main class="main-content">
        <component :is="currentComponent" :key="currentComponent" v-if="!iframeSrc"></component>
        <div
          style="margin: 0 0.38rem 3.521vh;height: calc(100% - 3.521vh); position: relative;"
          v-else
        >
          <div
            class="mask"
            v-if="activeMenu === 5"
            style="width: 130px; height: 50px; position: absolute; top: 0; left: 0"
          ></div>
          <iframe :src="iframeSrc" frameborder="0" width="100%" height="100%"></iframe>
        </div>
      </main>
    </div>

    <!-- AI助手侧边浮窗 -->
    <AiHelper v-if="showAiAssistant" :visible="showAiAssistant" @close="showAiAssistant = false" />
  </div>
</template>

<script>
  import { EventBus } from 'utils/bus'
  import { date } from 'utils'
  export default {
    name: 'waterSystem',
    data() {
      return {
        currentTime: '',
        currentDate: '',
        weekDay: '',
        timer: null,
        isFullScreen: false,
        isExpanded: true,
        activeMenu: 1,
        menuList: [
          {
            id: 1,
            name: '概览',
            icon: require('./img/home_dark.png'),
            hoverIcon: require('./img/home_selected_dark.png'),
            mark: 'waterView'
          },
          {
            id: 2,
            name: '实时监测',
            icon: require('./img/relaMonitor_dark.png'),
            hoverIcon: require('./img/relaMonitor_selected_dark.png'),
            mark: 'waterMonitor'
          },
          {
            id: 3,
            name: '水压监测',
            icon: require('./img/waterPressure_dark.png'),
            hoverIcon: require('./img/waterPressure_selected_dark.png'),
            mark: 'waterPressure'
          },
          {
            id: 4,
            name: '手自动监测',
            icon: require('./img/handleAutoMonitor_dark.png'),
            hoverIcon: require('./img/handleAutoMonitor_selected_dark.png'),
            mark: 'handleAutoMonitor'
          },
          {
            id: 5,
            name: '泵房监测',
            icon: require('./img/pump.png'),
            hoverIcon: require('./img/pump_selected.png'),
            mark: 'pumpRoom'
          }
        ],
        currentComponent: 'waterMonitor',
        iframeSrc: '',
        showAiAssistant: false, // 控制AI助手面板显示
        aiQuestion: '' // 用户输入的问题
      }
    },
    components: {
      WaterView: () => import('./pages/waterView'),
      WaterMonitor: () => import('./pages/waterMonitor'),
      AiHelper: () => import('./pages/aiHelper')
    },
    created() {
      // 监听全屏变化
      this.setupFullscreenListeners()
      EventBus.$on('check-more', this.handleReceive)
    },
    mounted() {
      this.enterfullscreen()
      this.initDateTime()
    },
    methods: {
      handleReceive(data) {
        let item = this.menuList.find(item => item.mark == data)
        this.activeMenu = item.id
        this.dealClick(item)
      },
      changeNav(item) {
        this.activeMenu = item.id
        this.dealClick(item)
      },
      dealClick(item) {
        if (item.mark == 'waterPressure') {
          this.iframeSrc = 'https://www.hikfirecloud.com/web/dashboard'
        } else if (item.mark == 'handleAutoMonitor') {
          this.iframeSrc =
            'https://iotidmp.saftysmartcontrol.com/#/accessLogin?key=MTU5OTY0MTAwODg=&secret=MTIzNDU2&routerName=pumpMonitor'
        } else if (item.mark == 'pumpRoom') {
          this.iframeSrc = 'https://diagnosis.sushine.net:8443/login'
        } else if (
          item.mark !== 'waterPressure' &&
          item.mark != 'handleAutoMonitor' &&
          item.mark != 'setting' &&
          item.makr != 'pumpRoom'
        ) {
          this.iframeSrc = ''
          this.currentComponent = item.mark
        }
      },
      // 初始化日期时间
      initDateTime() {
        let dates = date(new Date())
        this.currentDate = [dates.YY, dates.MM, dates.DD].join('.')
        let times = date(new Date())
        this.currentTime = [times.hh, times.mm, times.ss].join(':')
        this.timer = setInterval(() => {
          let times = date(new Date())
          this.currentTime = [times.hh, times.mm, times.ss].join(':')
        }, 1000)
        this.weekDay = '星期' + '日一二三四五六'.charAt(new Date().getDay())
      },
      // 设置全屏监听器
      setupFullscreenListeners() {
        let isFullScreen =
          document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.fullScreen ||
          document.mozFullScreen ||
          document.webkitIsFullScreen
        isFullScreen = !!isFullScreen

        const fullscreenChangeHandler = () => {
          this.isFullScreen = !isFullScreen
        }

        document.addEventListener('fullscreenchange', fullscreenChangeHandler)
        document.addEventListener('mozfullscreenchange', fullscreenChangeHandler)
        document.addEventListener('webkitfullscreenchange', fullscreenChangeHandler)
        document.addEventListener('msfullscreenchange', fullscreenChangeHandler)
      },

      //进入全屏
      enterfullscreen() {
        let docElm = document.documentElement
        if (!this.isFullScreen) {
          if (docElm.requestFullscreen) {
            docElm.requestFullscreen()
          } else if (docElm.mozRequestFullScreen) {
            docElm.mozRequestFullScreen()
          } else if (docElm.webkitRequestFullScreen) {
            docElm.webkitRequestFullScreen()
          } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen()
          }
        }
      },

      // 返回首页
      backHome() {
        this.exitFullscreen()
        this.$router.push({ name: 'home' })
      },

      // 退出全屏
      exitFullscreen() {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      },

      // 关闭AI助手面板
      closeAiPanel(event) {
        // 点击遮罩层关闭面板
        this.showAiAssistant = false
      },

      // 发送问题给AI助手
      sendQuestion() {
        if (!this.aiQuestion.trim()) {
          alert('请输入您的问题')
          return
        }

        // 这里可以集成实际的AI服务
        console.log('用户提问:', this.aiQuestion)
        alert(`已收到您的问题: ${this.aiQuestion}`)
        this.aiQuestion = '' // 清空输入框
      }
    },
    beforeDestroy() {
      EventBus.$off('check-more', this.handleReceive)
      if (this.timer) {
        clearInterval(this.timer)
      }
    }
  }
</script>

<style lang="less">
  html::-webkit-scrollbar {
    width: 0;
  }

  .mySelect {
    background: #043555;
    color: #a1b8de;

    .el-select-dropdown__item:hover,
    .el-select-dropdown__item.hover,
    .el-select-dropdown__item.selected {
      background: #0c5381;
      color: #cde0ff;
    }
  }

  /* AI助手按钮和面板样式 */
  .ai-assistant-btn {
    background-color: #409eff;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 6px 12px;
    margin-right: 0.1rem;
    cursor: pointer;
    font-size: 1.48vh;
  }

  .ai-assistant-btn:hover {
    background-color: #66b1ff;
  }

  .ai-assistant-panel {
    position: fixed;
    top: 0;
    right: 0;
    width: 25%;
    height: 80%;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .ai-assistant-content {
    width: 100%;
    max-width: 100%;
    height: 100%;
    background: #fff;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
  }

  .ai-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
    background-color: #f5f7fa;
  }

  .ai-header h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }

  .close-btn {
    font-size: 24px;
    cursor: pointer;
    color: #999;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }

  .close-btn:hover {
    background-color: #e6e6e6;
    color: #666;
  }

  .ai-body {
    padding: 20px;
    flex: 1;
    overflow-y: auto;
  }

  .ai-body p {
    margin-top: 0;
    color: #666;
    line-height: 1.6;
  }

  .ai-input-area {
    margin-top: 20px;
  }

  .ai-input-area textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    resize: vertical;
    font-size: 14px;
  }

  .send-btn {
    margin-top: 10px;
    padding: 8px 16px;
    background-color: #409eff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .send-btn:hover {
    background-color: #66b1ff;
  }
</style>

<style lang="less" scoped>
  @text-color-dark: #bdd2ff;
  @divider-color-dark: #bdd2ff;
  @bg-color-dark: #3d5176;
  @border-color-dark: #334971;
  @hover-bg-color-dark: #144da3;
  @hover-text-color-dark: #fff;
  @sider-text-color-dark: #bbcdf5;
  @sidebar-bottom-color-dark: #0d1a32;
  @sidebar-bottom-border-color-dark: #334971;

  .waterSystem {
    width: 100%;
    height: 100%;
    background: url('./img/bg_dark.png') no-repeat;
    background-size: 100% 100%;

    .navbar {
      height: 8.9vh;
      padding: 0 0.36rem 0 0.3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &_left {
        display: flex;
        align-items: center;

        img {
          width: 0.39rem;
          height: auto;
        }

        h1 {
          margin-left: 0.12rem;
          font-family: MicrosoftYaHei;
          font-size: 2.69vh;
          font-weight: Bold;
          letter-spacing: 1px;
          color: @text-color-dark;
        }
      }

      &_right {
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: MicrosoftYaHei;
        font-size: 1.48vh;
        letter-spacing: 1px;
        color: @text-color-dark;

        span:not(:last-child) {
          margin-right: 0.1rem;
        }

        .week {
          &::before,
          &::after {
            content: ' ';
            display: inline-block;
            width: 0.01rem;
            height: 1.48vh;
            background-color: @divider-color-dark;
            border-radius: 0.01rem;
            vertical-align: -0.19vh;
          }

          &::before {
            margin-right: 0.1rem;
          }

          &::after {
            margin-left: 0.1rem;
          }
        }
      }

      .exit {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        right: 0.06rem;
        top: 0.46vh;
        width: 0.31rem;
        height: 2.86vh;
        background: @bg-color-dark;
        border-radius: 100%;
        cursor: pointer;

        img {
          width: 0.19rem;
          height: auto;
        }
      }
    }

    .waterSystem-container {
      width: 100%;
      height: calc(100% - 8.9vh);
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;

      .sidebar {
        height: 100%;
        border-right: 1px solid @border-color-dark;
        font-family: MicrosoftYaHei;
        font-size: 1.67vh;
        color: @sider-text-color-dark;
        transition: width 0.3s ease;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        &.expanded {
          width: 2.36rem;
        }

        &.collapsed {
          width: 1rem;
        }

        .menuList {
          height: calc(100% - 18.74vh);
          flex-grow: 1;
          overflow: auto;
          padding: 0 0.16rem;

          .menuItem {
            padding: 0.46vh 0;

            .icon-container {
              position: relative;
              width: 0.21rem;
              height: 0.21rem;
              margin-right: 0.16rem;

              img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: auto;
                transition: opacity 0.3s ease;
              }

              .hover-icon {
                opacity: 0;
              }
            }

            a {
              height: 5.75vh;
              padding: 0 0.2rem;
              margin-bottom: 1.3vh;
              display: flex;
              align-items: center;
              transition: all 0.3s ease;
              cursor: pointer;
              text-decoration: none;
              border-radius: 0.19rem;
              color: @sider-text-color-dark;
            }

            a:hover,
            a.active {
              background: @hover-bg-color-dark;
              color: @hover-text-color-dark;

              .hover-icon {
                opacity: 1;
              }

              .default-icon {
                opacity: 0;
              }
            }

            img {
              width: 0.21rem;
              height: auto;
              margin-right: 0.16rem;
              transition: margin 0.3s ease;
            }

            .menu-text {
              white-space: nowrap;
              opacity: 1;
              transition: opacity 0.3s ease;
            }
          }
        }

        .bottom {
          border-top: 1px solid @sidebar-bottom-border-color-dark;
          height: 18.74vh;
          background: @sidebar-bottom-color-dark;
          padding-top: 3.34vh;
          padding-left: 0.36rem;

          .toggle {
            cursor: pointer;
            display: flex;
            align-items: center;

            img {
              width: 0.2rem;
              height: auto;
              margin-right: 0.16rem;
            }

            span {
              font-family: MicrosoftYaHei;
              font-size: 1.67vh;
              color: @sider-text-color-dark;
            }
          }
        }

        .collapsed {
          a > img {
            margin-right: 0;
          }

          .toggle > img {
            margin-right: 0;
          }

          .menu-text,
          .toggle_text {
            opacity: 0;
          }
        }
      }

      .main-content {
        height: 100%;
        flex-grow: 1;
        overflow: hidden;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/waterSystem/index.vue